import { render, staticRenderFns } from "./DiscussionBoardPostComments.vue?vue&type=template&id=2a60714e&"
import script from "./DiscussionBoardPostComments.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardPostComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports